import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchJobTitles: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'jobtitle/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_JOB_TITLE_REQUEST,
                        types.SEARCH_JOB_TITLE_SUCCESS,
                        types.SEARCH_JOB_TITLE_FAILURE
                    ]
                }
            });
        },

    saveJobTitle: (jobTitle) =>
        (dispatch) => {
            if (jobTitle.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'jobtitle/create',
                        method: 'POST',
                        body: jobTitle,
                        types: [
                            types.CREATE_JOB_TITLE_REQUEST,
                            types.CREATE_JOB_TITLE_SUCCESS,
                            types.CREATE_JOB_TITLE_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'jobtitle/update',
                        method: 'PUT',
                        body: jobTitle,
                        types: [
                            types.UPDATE_JOB_TITLE_REQUEST,
                            types.UPDATE_JOB_TITLE_SUCCESS,
                            types.UPDATE_JOB_TITLE_FAILURE
                        ]
                    }
                });
            }
        }
}
